module.exports = __webpack_public_path__ + "static/media/JFL Brick Campaign-2.6ec53fe7.jpg";